import { graphql } from "gql.tada";
import { TitleSectionFragment } from "../fragments/TitleSectionFragment";

export const TitleSectionById = graphql(
  `
    query TitleSectionById($locale: String, $preview: Boolean, $id: String!) {
      titleSection(id: $id, preview: $preview, locale: $locale) {
        ...TitleSectionFragment
      }
    }
  `,
  [TitleSectionFragment]
);
